// [ai] Minimal typed event emitter (the old core/events.js): the engine and the video window report through it; a listener that
// throws is logged and never stops its siblings.
export type EventMap = Record<string, unknown[]>;
type Listener = (...a: unknown[]) => void;
export class Emitter<E extends EventMap> {
  private h = new Map<keyof E, Set<Listener>>();
  on<K extends keyof E>(ev: K, fn: (...a: E[K]) => void): () => void {
    let set = this.h.get(ev); if (!set) { set = new Set(); this.h.set(ev, set); }
    set.add(fn as unknown as Listener); return () => this.off(ev, fn);
  }
  off<K extends keyof E>(ev: K, fn: (...a: E[K]) => void) { this.h.get(ev)?.delete(fn as unknown as Listener); }
  emit<K extends keyof E>(ev: K, ...a: E[K]) { for (const fn of [...(this.h.get(ev) ?? [])]) { try { fn(...a); } catch (e) { console.error("[dossier]", ev, e); } } }
}
